import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { ValidatableBlueprint } from '@/components/builder/base/blueprints/ValidatableBlueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { ValidationErrors } from '@/components/builder/base/types/ValidationErrors';
import { FormBuilderContract } from '@/components/builder/form';
import { BlueprintDefinition } from '@/components/builder/form/blueprints/BlueprintDefinition';
import { entry, Entry, instanceOfEntry } from '@/components/builder/form/entries/Entry';
import { ValidEntry } from '@/components/builder/form/entries/ValidEntry';
import { EntryFactory } from '@/components/builder/form/traits/EntryFactory';
import { HasLabel } from '@/components/builder/form/traits/HasLabel';
import { ProcessCallback } from '@/components/builder/form/types/ProcessCallback';

export const Definition: BlueprintDefinition = {
    type: 'accordion',
    name: '[[[Akordeon]]]',
    icon: 'fa-chevrons-down',
    group: 'special',
    position: 10
};

export enum ContentTypes {
    Textarea = 'Textarea',
    Editor = 'Editor'
}

export class AccordionItem
{
    public section: string = '';
    public content: string = '';
}

export class AccordionEntry extends ValidEntry<AccordionItem[]>
{
    public type: string = Definition.type;
    public data: AccordionItem[] = [];

    public constructor(data: any = null)
    {
        super();

        if (data !== null)
        {
            this.data = data;
        }
    }

    public async collect(
        blueprint: AccordionContract,
        form: FormBuilderContract,
        preprocess: ProcessCallback
    ): Promise<Entry>
    {
        return entry({
            type: this.type,
            data: this.data
        });
    }

    public validate(blueprint: AccordionContract, form: FormBuilderContract): boolean
    {
        this.errors = {};

        if (!this.data.any())
            return this.valid();

        for (const item of this.data)
        {
            if (item.content.length === 0 || item.section.length === 0)
            {
                this.errors.value = [`[[[Pole "%0" wymaga uzupełnienia wszystkich elementów|||${form.localization.translate(blueprint.label)}]]]`];
            }
        }

        return this.valid();
    }
}

export const instanceOfAccordionEntry = (object: any): object is AccordionEntry =>
{
    return instanceOfEntry(object) && 'type' in object && object.type === Definition.type;
};

export interface AccordionContract extends Blueprint, HasWidth, HasLabel
{
    contentType: ContentTypes;
}

export class AccordionType implements AccordionContract, ValidatableBlueprint, EntryFactory<AccordionEntry>
{
    public id: string;
    public type: string;
    public name: string;
    public minWidth: number;
    public width: number;
    public label: Record<string, string>;
    public showLabel: boolean;
    public contentType: ContentTypes;
    public errors: ValidationErrors;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.minWidth = 3;
        this.width = 0;
        this.label = { 'pl-PL': 'Akordeon' };
        this.showLabel = true;
        this.contentType = ContentTypes.Textarea;
        this.errors = {};
    }

    public setDefaultWidth(width: number): void
    {
        this.width = Math.min(3, Math.max(this.minWidth, width));
    }

    public createEntry(data: any): AccordionEntry
    {
        return new AccordionEntry(data);
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return {
            [this.name]: this.errors
        };
    }
}
